module.exports = __webpack_public_path__ + "static/media/newsOne.13887487.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowFour/newsOne.jpg
// module id = 67
// module chunks = 0